import { Form } from 'react-bootstrap';

const EditSingleAccessibility = ({ accessibility, index, handleChange, language }) => {
    return (
        <Form.Group>
            <div className="my-1">
            <Form.Label>Type</Form.Label>
            <Form.Control as="select" value={accessibility.type} onChange={e => { handleChange(index, 'type', e.target.value) } }>
                <option>Infrastructure</option>
                <option>Service</option>
            </Form.Control>
            </div>
            <div className="my-1">
                <Form.Label>Services *</Form.Label>
                <Form.Control as="textarea" required value={accessibility.services} rows={3} onChange={e => handleChange(index, 'services', e.target.value) } />
            </div>
            <div className="my-1">
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" rows={3} value={accessibility.description} onChange={e => handleChange(index, 'description', e.target.value) } />
            </div>
            <div className="row">
                <div className="col-md-4">
                    <Form.Label>Email *</Form.Label>
                    <Form.Control type="email" placeholder="example@auth.gr" required value={accessibility.info.email} onChange={e => handleChange(index, 'info', { ...accessibility.info, email: e.target.value })} />
                </div>
                <div className="col-md-8">
                    <Form.Label>Phone *</Form.Label>
                    <Form.Control type="text" pattern="\+30[0-9]{10}" placeholder="Phone number in the E.164 format, with the leading “+” sign. e.g. : +302310996727" value={accessibility.info.phone} required onChange={e => handleChange(index, 'info', { ...accessibility.info, phone: e.target.value })} />
                </div>
            </div>
            {
                accessibility?.info?.urls ? 
                    accessibility.info.urls.map((url, idx) => (
                                <div className="form-group" key={url + idx}>
                                    <label className='d-block'>Url *</label>
                                    <div className="d-flex justify-content-between">
                                        <input type="url" placeholder="https://example.com" pattern="https?://.*" required value={url.value} className={`form-control ${accessibility.info.urls.length !== 1 ? 'col-md-9' : 'col-md-12' } d-inline-block`} onChange={e => {
                                            const newArray = Array.from(accessibility.info.urls);
                                            newArray.splice(idx, 1, { ...accessibility.info.urls[idx], value: e.target.value })

                                            handleChange(index, 'info', { ...accessibility.info, urls: newArray });
                                        }}/>
                                        {
                                            accessibility.info.urls.length !== 1 ? 
                                                <button className='btn btn-danger col-md-2 d-inline-block align-self-center' onClick={(e) => {
                                                    e.preventDefault()
                                                    
                                                    const newArray = Array.from(accessibility.info.urls);
                                                    newArray.splice(idx, 1)
                                                    
                                                    handleChange(index, 'info', { ...accessibility.info, urls: newArray });
                                                }}>
                                                    <i className="fa fa-trash mr-2"></i>
                                                    Delete URL
                                                </button> 
                                            : 
                                                <></>
                                        }
                                    </div>
                                </div>
                    )) 
                :
                    <></>
            }
            <div className="d-flex justify-content-around">
                <button className='btn btn-primary btn-sm mb-2 btn-next' onClick={(e) => {
                    e.preventDefault()
                    handleChange(index, 'info', accessibility?.info?.urls ? 
                        ({
                            ...accessibility.info,
                            urls: [
                                ...accessibility.info.urls,
                                {
                                    value: '',
                                    language: 'en'
                                }
                            ]
                        })
                    : 
                        {
                            ...accessibility.info,
                            urls: [{ value: '', language: 'en' }]
                        }
                    )
                }}>
                    <i className="fa fa-plus mr-2"></i>
                    Add URL
                </button>
            </div>
            <div className="my-1">
                <Form.Label>Language</Form.Label>
                <Form.Control type="text" readOnly value={language}/>
            </div>
        </Form.Group>
    );
};

export default EditSingleAccessibility;